<template lang="pug">
.container-error.pt-2.pl-2.pr-2.pb-2.mb-3.mt-0
  v-icon.mr-1.mb-1(small, :color="colorIcon") info
  <ul v-if="errors" :class="{ 'singleError': singleError }">
    <li v-for="error in errors">
      span.wrap-content(v-html="error")
    </li>
    div(v-if='isCampaignFailed')
      <li>
        <span class='font-weight-bold'> {{ boldWarningMsg }}</span> {{ warningMsg }}
      </li>
      <li> Need help fixing your registration? 
          a(:href='campaignFailedSupportEmail') Contact support
          |  for assistance.
      </li>
  </ul>
  slot(name="customError")
</template>
<script>

import { REGISTRATION_STATES } from '../../Text/config/registrationStatus';

export default {
  components: {
  },
  name: 'CustomErrorRegistration',
  props: {
    errors: {
      type: Array,
      default () {
        return [];
      },
    },
    registrationStatus10dlc: {
      type: String,
      default: '',
    },
    registrationCampaignRetries: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      colorIcon: '#FF0000',
    }
  },
  computed: {
    singleError() {
      return (
        this.isCampaignFailed ? !this.isCampaignFailed :
        this.errors.length === 1
      );
    },
    isCampaignFailed() {
      return (this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_TCR_FAILED ||
      this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_TWILIO_FAILED
      );
    },
    campaignFailedSupportEmail() {
      const email = 'support@liondesk.com';
      const subject = encodeURIComponent(this.emailSubject);

      const lineBreak = '\n\n';
      const mapErrors = this.errors.map(x => x).join(lineBreak);
      const body = encodeURIComponent(`My registration is returning this error after multiple attempts: ${lineBreak}${mapErrors}`);
       
      return `mailto:${email}?subject=${subject}&body=${body}`;
    },
    emailSubject() {
      return (
        this.registrationCampaignRetries ? 'Texting: Registration assistance - message types (restart fee)' : 'Texting: Registration assistance - message types (free retry)'
      );
    },
    boldWarningMsg() {
      return (
        this.registrationCampaignRetries ? 'This submission will restart your message type registration.' : 'This is your free retry attempt.'
      );
    },
    warningMsg() {
      return (
        this.registrationCampaignRetries ? 'US carriers will charge you for a verification restart fee to continue. Please follow exact form instructions to avoid errors.' :
        'Future attempts will incur a new restart fee. Please follow exact form instructions to avoid errors.'
      );
    },
  },
};
</script>
<style lang="scss" scoped>

.container-error {
  display: flex;
  min-height: 40px;
  border: 2px solid red;
  border-radius: 10px;

  ul {
    color: red;
    font-weight: 500;
  }

  .singleError {
    list-style: none;
    padding-left: 10px;
  }
}

.wrap-content {
  overflow-wrap: anywhere;
}

</style>

